module.exports = __webpack_public_path__ + "img/microsoft-auth-app.cf597989.png";